import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column-reverse',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
    },
    paddingBottom: 80, // Add padding to prevent content from being hidden behind fixed buttons
  },
  list: {
    padding: 24,
  },
  searchInput: {
    width: '100%',
    marginBottom: 12,
  },
  buttons: {
    padding: theme.spacing(2),
  },
}));
